import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MediaThumbnailComponent } from '@x/common/media-thumbnail/media-thumbnail.component';
import { OrderSnackbarComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/snackbar-ui/components/order-snackbar/order-snackbar.component';
import { GeneralSnackbarComponent } from './components/general-snackbar/general-snackbar.component';

@NgModule({
  declarations: [GeneralSnackbarComponent, OrderSnackbarComponent],
  imports: [CommonModule, FontAwesomeModule, MediaThumbnailComponent],
  exports: [GeneralSnackbarComponent, OrderSnackbarComponent],
})
export class SnackbarUiModule {}
